import { render } from "./DesignerContent.vue?vue&type=template&id=7fc7968a&scoped=true"
import script from "./DesignerContent.vue?vue&type=script&lang=js"
export * from "./DesignerContent.vue?vue&type=script&lang=js"

import "./DesignerContent.vue?vue&type=style&index=0&id=7fc7968a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7fc7968a"

export default script